// -------------------------
// jQuery
// -------------------------
import $ from 'jquery';
window.$ = window.jQuery = $;

// Passive event fixes
['touchstart', 'touchmove', 'wheel', 'mousewheel'].forEach(ev =>
    $.event.special[ev] = {
        setup: function (_, ns, handle) {
            this.addEventListener(ev, handle, { passive: true });
        }
    }
);

// -------------------------
// Web Fonts
// -------------------------
import WebFont from 'webfontloader';
WebFont.load({
    typekit: { id: 'prx7sxf' },
    active: () => {
        document.documentElement.classList.add("fonts-loaded");
        ScrollTrigger.refresh(); // refresh after fonts load
    }
});

// -------------------------
// Page Loader
// -------------------------
document.addEventListener("DOMContentLoaded", () => {
    const loader = document.getElementById("page-loader");
    const siteContent = document.getElementById("site-content");

    if (!loader || !siteContent) return;

    window.addEventListener("load", () => {
        setTimeout(() => {
            loader.classList.add("hidden");
            siteContent.classList.add("visible");
        }, 100);
    });
});

// -------------------------
// GSAP + ScrollTrigger + SplitText + Lenis
// -------------------------
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { SplitText } from 'gsap/SplitText';
import ScrollSmoother from 'gsap/ScrollSmoother';


gsap.registerPlugin(ScrollTrigger, SplitText, ScrollSmoother);

// ✅ Init ScrollSmoother
const smoother = ScrollSmoother.create({
    smooth: 1.2,
    effects: true,
    normalizeScroll: true,
    ignoreMobileResize: true,
    // Add any elements that are position fixed in css:
    fixedElements: '.video-overlay'
});

window.addEventListener("load", () => {
    ScrollTrigger.refresh();
});
window.addEventListener("resize", () => {
    ScrollTrigger.refresh();
});

// -------------------------
// Modules
// -------------------------

// Load Libraries
import { initSwipers } from './modules/swipers.js';
initSwipers();
import 'magnific-popup/dist/jquery.magnific-popup.min';

// Load Custom Modules
import './modules/navigation.js';
import './modules/searchAutocomplete.js';
import './modules/animations.js';
import './modules/video.js';
import { initPagination } from './modules/pagination.js';

document.addEventListener('DOMContentLoaded', function () {
    initPagination('#case-studies-list');
    initPagination('#news-articles-list');
    initPagination('#events-articles-list');
});